// HTTP and domain status constants
export const HTTP_STATUS = {
  SUCCESS: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHENTICATED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
} as const;

export const ExecutionStatus = {
  PENDING: 'pending',
  RUNNING: 'running',
  COMPLETED: 'completed',
  FAILED: 'failed',
} as const;

export type ExecutionStatusType = (typeof ExecutionStatus)[keyof typeof ExecutionStatus];

export const ModelStatus = {
  DRAFT: 'draft',
  ACTIVE: 'active',
  ARCHIVED: 'archived',
  TRAINING: 'training',
  FAILED: 'failed',
} as const;

export type ModelStatusType = (typeof ModelStatus)[keyof typeof ModelStatus];

export const ScenarioStatus = {
  ACTIVE: 'active',
  ARCHIVED: 'archived',
  FAILED: 'failed',
  DELETED: 'deleted',
} as const;

export type ScenarioStatusType = (typeof ScenarioStatus)[keyof typeof ScenarioStatus];

export const ComponentState = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
} as const;

export type ComponentStateType = (typeof ComponentState)[keyof typeof ComponentState];
